"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validation_result_type_1 = require("./validation-result-type");
var ValidationFail = /** @class */ (function () {
    function ValidationFail(message) {
        this.type = validation_result_type_1.ValidationResultType.Fail;
        this.message = message;
    }
    return ValidationFail;
}());
exports.ValidationFail = ValidationFail;
function isFailure(result) {
    return result.type === validation_result_type_1.ValidationResultType.Fail;
}
exports.isFailure = isFailure;
